import React from 'react';
import {createBrowserRouter, RouteObject} from 'react-router-dom';
import App from '../../App';
import Home from '../layout/pages/Home';
import ProtectedRoute from './ProtectedRoutes';
import TitleDetails from '../layout/pages/TitleDetails';
import SectionTemplates from '../layout/pages/SectionTemplates';
import Users from '../layout/pages/Users';
import SubscriptionCallback from '../layout/pages/SubscriptionCallback';
import TitleBank from '../layout/pages/TitleBank';
import Dashboard from '../layout/pages/Dashboard';
import Subscription from '../layout/pages/Subscription';
import TemplateDetails from '../layout/pages/TemplateDetails';
import CompletedOrders from '../layout/pages/CompletedProjects';
import TitleSummaryReport from '../layout/pages/TitleSummaryReport';
import LineListReport from '../layout/pages/LineListReport';
import MarketplaceManagement from '../layout/pages/MarketplaceManagement';
import Settings from '../layout/pages/Settings';
import BillingCallback from '../layout/pages/BillingCallback';
import BusinessRecordManagement from '../layout/pages/BusinessRecordManagement';
import GrantAI from '../layout/pages/GrantAI';
import SelfRegistration from '../layout/pages/SelfRegistration';
import UserInvitations from '../layout/pages/UserInvitations';
import MarketplaceSearch from '../layout/pages/MarketplaceSearch';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '',
        element: <Home />
      },
      {
        path: 'dashboard',
        element: (
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        )
      },
      {
        path: 'completed-files',
        element: (
          <ProtectedRoute>
            <CompletedOrders />
          </ProtectedRoute>
        )
      },
      {
        path: 'title-bank',
        element: (
          <ProtectedRoute>
            <TitleBank />
          </ProtectedRoute>
        )
      },
      {
        path: 'organization/:organizationId/title/:titleId',
        element: (
          <ProtectedRoute>
            <TitleDetails />
          </ProtectedRoute>
        )
      },
      {
        path: 'subscription',
        element: <Subscription />
      },
      {
        path: 'subscription/:status',
        element: <SubscriptionCallback />
      },
      {
        path: 'billing/tokens/:status',
        element: <BillingCallback />
      },
      {
        path: 'section-templates',
        element: (
          <ProtectedRoute>
            <SectionTemplates />
          </ProtectedRoute>
        )
      },
      {
        path: 'users',
        element: (
          <ProtectedRoute>
            <Users />
          </ProtectedRoute>
        )
      },
      {
        path: 'user-invitations',
        element: (
          <ProtectedRoute>
            <UserInvitations />
          </ProtectedRoute>
        )
      },
      {
        path: 'template-details',
        element: (
          <ProtectedRoute>
            <TemplateDetails />
          </ProtectedRoute>
        )
      },
      {
        path: 'organization/:organizationId/title/:titleId/title-summary-report',
        element: (
          <ProtectedRoute>
            <TitleSummaryReport />
          </ProtectedRoute>
        )
      },
      {
        path: 'organization/:organizationId/title/:titleId/line-list-report',
        element: (
          <ProtectedRoute>
            <LineListReport />
          </ProtectedRoute>
        )
      },
      {
        path: 'settings',
        element: (
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        )
      },
      {
        path: 'marketplace-management',
        element:(
          <ProtectedRoute>
            <MarketplaceManagement />
          </ProtectedRoute>
        )
      },
      {
        path: 'marketplace-search',
        element: (
          <ProtectedRoute>
            <MarketplaceSearch />
          </ProtectedRoute>
        )
      },
      {
        path: 'business-record-management',
        element: (
          <ProtectedRoute>
            <BusinessRecordManagement />
          </ProtectedRoute>
        )
      },
      {
        path: 'grant-ai',
        element: (
          <ProtectedRoute>
            <GrantAI />
          </ProtectedRoute>
        )
      },
      {
        path: 'self-registration',
        element: <SelfRegistration />
      }
      // {
      //   path: 'business-record-search',
      //   element: (
      //     <ProtectedRoute>
      //       <BusinessRecordSearch />
      //     </ProtectedRoute>
      //   )
      // }
    ]
  }
];

export const router = createBrowserRouter(routes);
